import { useState,useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography, Autocomplete, Button } from '@mui/material';
import { ButtonBasic, SelectAcciones, SelectUser } from '../../components';
import AccionesService from '../../services/acciones.service';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ModalPermisos = ({show, hideModal, item, onGuardar, type}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [rolSeleccionado, setRolSeleccionado] = useState(null);
    const handleClose = () => hideModal();
    const [formAll, setFormAll] = useState({
        nombre_r: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        acciones: {
            texto: [],
            textoErr: 'Las acciones son requeridas',
            estadoErr: false,
            tipo: 'string'
        },
        personas: {
            texto: [],
            textoErr: 'El personal es requerido',
            estadoErr: false,
            tipo: 'string'
        }
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if(!value || value === ''){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {};
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['nombre_r','acciones','personas']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_r > 0) {
                form.id_r = item.id_r
                AccionesService.update(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }else{
                AccionesService.register(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            onChangeForm(item?.nombre_r,'nombre_r')
            if(item.users?.length > 0){
                onChangeForm(item.users?.map(ur=>ur?.id_p),'personas')
            }
            if(item.autorizado?.length > 0){
                onChangeForm(item.autorizado?.map(au=>au?.accionId_rxa),'acciones')
            }
        }
    }, [item])

    useEffect(() => {
        if(show){
            cargarRoles();
        }
    }, [show])

    const cargarRoles = async () => {
        try {
            const response = await AccionesService.getAllAutorizados();
            if(response){
                // Filtrar el rol actual si estamos editando
                const rolesDisponibles = item?.id_r > 0 
                    ? response.filter(r => r.id_r !== item.id_r)
                    : response;
                setRoles(rolesDisponibles);
            }
        } catch (error) {
            console.error('Error al cargar roles:', error);
        }
    }

    const copiarPermisos = () => {
        console.log('rolSeleccionado completo:', rolSeleccionado);
        if(rolSeleccionado){
            // Copiar usuarios y acciones en una sola actualización
            const usuarios = rolSeleccionado.users?.length > 0 
                ? rolSeleccionado.users.map(ur => ur?.id_p) 
                : [];
            
            const acciones = rolSeleccionado.autorizado?.length > 0 
                ? rolSeleccionado.autorizado.map(au => au?.accionId_rxa) 
                : [];
            
            console.log('usuarios extraídos:', usuarios);
            console.log('acciones extraídas:', acciones);
            
            // Actualizar ambos campos al mismo tiempo
            setFormAll(prev => {
                const newForm = {
                    ...prev,
                    personas: {
                        ...prev.personas,
                        texto: usuarios,
                        estadoErr: usuarios.length === 0
                    },
                    acciones: {
                        ...prev.acciones,
                        texto: acciones,
                        estadoErr: acciones.length === 0
                    }
                };
                console.log('nuevo formAll:', newForm);
                return newForm;
            });
            
            setRolSeleccionado(null);
        }
    }

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: isDarkMode ? '#e0e0e0' : '#000',
                borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                height: 50,
            },
            '&:hover': {
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#3d4a62' : 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 45,
        }
    }), [isDarkMode]);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_r > 0 ? 'Editar Rol' : 'Registrar Rol'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{
                                border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, 
                                borderRadius: 2, 
                                p: 2, 
                                bgcolor: isDarkMode ? '#1F2A40' : '#fafafa',
                                mb: 1
                            }}>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 1.5}}>
                                    <ContentCopyIcon sx={{color: isDarkMode ? '#90caf9' : '#1976d2', fontSize: 20}} />
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 500, fontSize: 14}}>
                                        Copiar permisos de otro rol
                                    </Typography>
                                </Box>
                                <Box sx={{display: 'flex', gap: 1, alignItems: 'flex-start', flexDirection: {xs: 'column', sm: 'row'}}}>
                                    <Box sx={{flex: 1, width: '100%'}}>
                                        <Autocomplete
                                            options={roles}
                                            getOptionLabel={(option) => option.nombre_r || ''}
                                            value={rolSeleccionado}
                                            onChange={(event, newValue) => setRolSeleccionado(newValue)}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label="Buscar rol" 
                                                    placeholder="Seleccione un rol..."
                                                    size="small"
                                                />
                                            )}
                                            noOptionsText="No hay roles disponibles"
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    bgcolor: isDarkMode ? '#1F2A40' : '#fff',
                                                    color: isDarkMode ? '#e0e0e0' : '#000',
                                                    padding: '4px !important',
                                                    '& fieldset': {
                                                        borderColor: isDarkMode ? '#3d4a62' : '#ccc',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: isDarkMode ? '#90caf9' : '#1976d2',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: isDarkMode ? '#90caf9' : '#1976d2',
                                                    },
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: isDarkMode ? '#b0bec5' : 'rgba(0, 0, 0, 0.6)',
                                                },
                                                '& .MuiAutocomplete-popupIndicator': {
                                                    color: isDarkMode ? '#b0bec5' : '#666',
                                                },
                                                '& .MuiAutocomplete-clearIndicator': {
                                                    color: isDarkMode ? '#b0bec5' : '#666',
                                                }
                                            }}
                                            componentsProps={{
                                                paper: {
                                                    sx: {
                                                        bgcolor: isDarkMode ? '#2d3a52' : '#fff',
                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                        '& .MuiAutocomplete-listbox': {
                                                            bgcolor: isDarkMode ? '#2d3a52' : '#fff',
                                                            '& .MuiAutocomplete-option': {
                                                                color: isDarkMode ? '#e0e0e0' : '#000',
                                                                '&:hover': {
                                                                    bgcolor: isDarkMode ? '#1F2A40' : '#f5f5f5',
                                                                },
                                                                '&[aria-selected="true"]': {
                                                                    bgcolor: isDarkMode ? '#1F2A40' : '#e3f2fd',
                                                                    '&:hover': {
                                                                        bgcolor: isDarkMode ? '#3d4a62' : '#bbdefb',
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </Box>
                                    <Button
                                        variant="contained"
                                        disabled={!rolSeleccionado}
                                        onClick={copiarPermisos}
                                        startIcon={<ContentCopyIcon />}
                                        sx={{
                                            textTransform: 'none',
                                            minWidth: {xs: '100%', sm: '120px'},
                                            height: 40,
                                            fontWeight: 500,
                                            bgcolor: isDarkMode ? '#90caf9' : '#1976d2',
                                            '&:hover': {
                                                bgcolor: isDarkMode ? '#64b5f6' : '#1565c0',
                                            },
                                            '&.Mui-disabled': {
                                                bgcolor: isDarkMode ? '#3d4a62' : '#e0e0e0',
                                                color: isDarkMode ? '#808b9e' : '#999',
                                            }
                                        }}
                                    >
                                        Copiar
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Nombre</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.nombre_r.texto}
                                error={formAll.nombre_r.estadoErr}
                                helperText={formAll.nombre_r.estadoErr && formAll.nombre_r.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'nombre_r')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Acciones</Typography>
                            <SelectAcciones
                                value={formAll.acciones.texto}
                                onChange={(opt)=>onChangeForm(opt.map(op=>(op.value)),'acciones')}
                                isMulti
                            />
                            {formAll.acciones.estadoErr && (
                                <Typography sx={{color: isDarkMode ? '#f87171' : 'red',fontSize:11,marginLeft:1}}>{formAll.acciones.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Usuarios</Typography>
                            <SelectUser
                                value={formAll.personas.texto}
                                filter='all'
                                onChange={(opt) => onChangeForm(opt.map(op=>(op.value)),'personas')}
                                isMulti
                            />
                            {formAll.personas.estadoErr && (
                                <Typography sx={{color: isDarkMode ? '#f87171' : 'red',fontSize:11,marginLeft:1}}>{formAll.personas.textoErr}</Typography>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                        isDisabled={formAll?.acciones?.texto?.length === 0 || formAll?.personas?.texto?.length === 0}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalPermisos